<template>
  <div class="checkbox" :class="{ disabled: disabled }">
    <!-- Enabled states -->
    <img @click="isChecked = false" v-show="isChecked && !disabled" src="../../assets/checkedbox.svg" />
    <img @click="isChecked = true" v-show="!isChecked && !disabled" src="../../assets/uncheckedbox.svg" />
    <!-- Disabled states -->
    <img v-show="isChecked && disabled" src="../../assets/checkedbox-disabled.svg" />
    <img v-show="!isChecked && disabled" src="../../assets/uncheckedbox-disabled.svg" />
    <label @click="disabled ? null : (isChecked = !isChecked)" v-if="label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isChecked: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  img {
    margin-right: 0.2rem;
  }

  label {
    cursor: pointer;
    font-size: $fontSize14;
    user-select: none;
  }

  &.disabled {
    cursor: default;
  }
}
</style>
